import { render } from "./ChatInput.vue?vue&type=template&id=c5d62ef2&scoped=true"
import script from "./ChatInput.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatInput.vue?vue&type=script&setup=true&lang=js"

import "./ChatInput.vue?vue&type=style&index=0&id=c5d62ef2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5d62ef2"],['__file',"src/common/widgets/ChatInput.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c5d62ef2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c5d62ef2', __exports__)) {
    api.reload('c5d62ef2', __exports__)
  }
  
  module.hot.accept("./ChatInput.vue?vue&type=template&id=c5d62ef2&scoped=true", () => {
    api.rerender('c5d62ef2', render)
  })

}


export default __exports__